import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './styles/theme.css';
import './styles/app.css';
import './i18n';
import { ThemeProvider } from './theme/ThemeProvider';
import { App } from './app/App';
import { LoginScreen } from './pages/LoginScreen';
import { USE_API } from './api/client';
import { getSession } from './api/session';
import { loadCases } from './api/caseStore';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found');
}

function render(node: React.ReactNode) {
  createRoot(container!).render(
    <StrictMode>
      <ThemeProvider>{node}</ThemeProvider>
    </StrictMode>
  );
}

async function boot() {
  // API mode requires a real session (case/assessment validate it against identity).
  if (USE_API && !getSession()) {
    render(<LoginScreen />);
    return;
  }
  if (USE_API) {
    try {
      await loadCases();
    } catch (err) {
      console.error('API bootstrap failed', err);
    }
  }
  render(<App />);
}

void boot();
